import { render, staticRenderFns } from "./CompanyPLWidgets.vue?vue&type=template&id=6c2ee0a3&"
import script from "./CompanyPLWidgets.vue?vue&type=script&lang=js&"
export * from "./CompanyPLWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports